import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import WhiteLabelConfiguration from '../../../utils/WhiteLabelConfiguration';
import whiteLogo from '../../../utils/images/bloomifai_logo.png';

/**
 * @package virtuOwl
 * @type {React.ComponentClass}
 */
class GetImage extends Component {
    static propTypes = {
        islogo: PropTypes.bool,
        isInslogo: PropTypes.bool,
        isccLogo: PropTypes.bool,
        isAppStore: PropTypes.bool,
        isPlayStore: PropTypes.bool,
        isTechnology: PropTypes.bool,
        className: PropTypes.string,
        width: PropTypes.string,
        style: PropTypes.any,
    };

    constructor(props) {
        super(props);
        this.state = {};
    }

    //returnLogoImage
    returnLogoImage = () => {
        const { className, width, style } = this.props;
        if (WhiteLabelConfiguration.logoType && WhiteLabelConfiguration.logoType === 'Image') {
            return (
                <img
                    className={className}
                    src={WhiteLabelConfiguration.logo}
                    alt={WhiteLabelConfiguration.appname}
                    width={width}
                    style={style}
                />
            );
        } else {
            return (
                <p className={className} width={width} style={{ color: 'black', fontSize: '35px' }}>
                    {WhiteLabelConfiguration.logo}
                </p>
            );
        }
    };

    //returnInsLogoImage
    returnInsLogoImage = () => {
        const { className, width, style } = this.props;
        if (WhiteLabelConfiguration.logoType && WhiteLabelConfiguration.logoType === 'Image') {
            return (
                <img
                    className={className}
                    src={WhiteLabelConfiguration.ins_logo}
                    alt={WhiteLabelConfiguration.appname}
                    width={width}
                    style={style}
                />
            );
        } else {
            return (
                <p className={className} width={width} style={{ color: 'black', fontSize: '35px' }}>
                    {WhiteLabelConfiguration.ins_logo}
                </p>
            );
        }
    };

    //returnBranchAdminLogoImage
    returnBranchAdminLogoImage = () => {
        const { className, width, style } = this.props;
        if (WhiteLabelConfiguration.logoType && WhiteLabelConfiguration.logoType === 'Image') {
            return (
                <img
                    className={className}
                    src={WhiteLabelConfiguration.ins_branch_admin_logo}
                    alt={WhiteLabelConfiguration.appname}
                    width={width}
                    style={style}
                />
            );
        } else {
            return (
                <p className={className} width={width} style={{ color: 'black', fontSize: '35px' }}>
                    {WhiteLabelConfiguration.isBranchAdminlogo}
                </p>
            );
        }
    };

    //returnGhrrLogoImage
    returnGhrrLogoImage = () => {
        const { className, width, style } = this.props;
        if (WhiteLabelConfiguration.logoType && WhiteLabelConfiguration.logoType === 'Image') {
            return (
                <img
                    className={className}
                    src={WhiteLabelConfiguration.ghrr_logo}
                    alt={WhiteLabelConfiguration.appname}
                    width={width}
                    style={style}
                />
            );
        } else {
            return (
                <p className={className} width={width} style={{ color: 'black', fontSize: '35px' }}>
                    {WhiteLabelConfiguration.isGhrrLogo}
                </p>
            );
        }
    };

    //returnVideoLogoImage
    returnVideoLogoImage = () => {
        const { className, width, style } = this.props;
        if (WhiteLabelConfiguration.logoType && WhiteLabelConfiguration.logoType === 'Image') {
            return (
                <img
                    className={className}
                    src={whiteLogo}
                    alt={whiteLogo}
                    width={width}
                    style={style}
                />
            );
        } else {
            return (
                <p className={className} width={width} style={{ color: 'black', fontSize: '35px' }}>
                    {WhiteLabelConfiguration.logoIcon}
                </p>
            );
        }
    };

    //renderTypeOfImages
    renderTypeOfImages = () => {
        const {
            islogo,
            isInslogo,
            isccLogo,
            isAppStore,
            isPlayStore,
            isTechnology,
            isVideoLogo,
            isBranchAdminlogo,
            isGhrrLogo,
        } = this.props;
        const {
            returnLogoImage,
            returnInsLogoImage,
            returnBranchAdminLogoImage,
            returnCCLogoImage,
            returnAppStoreImage,
            returnPlayStoreImage,
            returnTechnologyImage,
            returnVideoLogoImage,
            returnGhrrLogoImage,
        } = this;

        if (islogo) {
            return returnLogoImage();
        } else if (isInslogo) {
            return returnInsLogoImage();
        } else if (isBranchAdminlogo) {
            return returnBranchAdminLogoImage();
        } else if (isccLogo) {
            return returnCCLogoImage();
        } else if (isAppStore) {
            return returnAppStoreImage();
        } else if (isPlayStore) {
            return returnPlayStoreImage();
        } else if (isTechnology) {
            return returnTechnologyImage();
        } else if (isVideoLogo) {
            return returnVideoLogoImage();
        } else if (isGhrrLogo) {
            return returnGhrrLogoImage();
        }
    };

    render() {
        return this.renderTypeOfImages();
    }
}

export default connect()(GetImage);
